import renderLocale from '../helpers/renderLocale';

const convertToCurrency = (number: number | string) => {
  // If the language has french (fr) in it, then move the dollar sign to the end with a space
  const locale = renderLocale();

  if (number === null || number === undefined) return null;

  const currencyString = number
    .toLocaleString(locale)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return locale && locale.toLowerCase().includes('fr')
    ? `${currencyString} $`
    : `$${currencyString}`;
};

export default convertToCurrency;
